
import Toasted from 'vue-toasted';
import Vue from "vue";

Vue.use(Toasted);

Vue.toasted.register('appStyle',
    (message) => {
        return message;
    },
    {
        position:'bottom-right',
        action : {
            icon:'close',
            class:'toastAction',
            onClick : (e, toastObject) => {
                toastObject.goAway(0);
            }
        }
    }
)

Vue.toasted.register('success',
    (message) => {
        return message;
    },
    {
        position:'bottom-right',
        action : {
            icon:'check',
            class:'toastActionSuccess',
            onClick : (e, toastObject) => {
                toastObject.goAway(0);
            }
        }
    }
)

Vue.toasted.register('error',
    (message) => {
        return message;
    },
    {
        position:'bottom-right',
        action : {
            icon:'close',
            class:'toastActionError',
            onClick : (e, toastObject) => {
                toastObject.goAway(0);
            }
        }
    }
)
